<template>
  <!-- 数据查询 -->
  <el-row type="flex" class="flex-grow-1 align-items-stretch" :gutter="12">
    <el-col
      :span="5"
      class="d-flex flex-column section-container"
      :class="{ dark: skinType }"
    >
      <project-tree-selector
        class="flex-grow-1"
        @select-node="selectNodeListener"
        @node-list="nodeListChangeListener"
        :span="8"
      ></project-tree-selector>
    </el-col>
    <el-col :span="19" class="d-flex flex-column">
      <div
        class="selector-container d-flex align-items-center section-container"
        :class="{ dark: skinType }"
      >
        <SectionTitle title="数据查询"></SectionTitle>
        <breadcrumbs
          :selectNode="selectNode"
          :nodeList="nodeList"
        ></breadcrumbs>
      </div>
      <!-- 條件查詢 -->
      <duration-selector
        class="section-container"
        :class="{ dark: skinType }"
        @select-duration="selectDurationListener"
        @select-derive="requestselectderive"
      ></duration-selector>
      <div
        class="props-container section-container d-flex justify-content-start"
        v-if="propertyList.length > 0"
        :class="{ dark: skinType }"
      >
        <el-checkbox-group
          v-model="selectProperties"
          @change="selectPropertiesStorage = selectProperties"
          class="check-box-group"
          style="text-align: left"
          :max="3"
          size="mini"
        >
          <el-checkbox
            v-for="option of propertyList"
            :key="option.PropertyId"
            :label="option.PropertyId"
            >{{ option.PropertyName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <el-tabs
        class="flex-grow-1 section-container"
        style="margin-top: 12px"
        :class="{ dark: skinType }"
        type="border-card"
        v-model="selectLabel"
      >
        <!-- 趋势图 -->
        <el-tab-pane label="趋势图">
          <charts
            v-if="chartsData"
            :options="chartsData"
            :resize="parseInt(selectLabel, 10)"
            class="flex-grow-1 d-flex"
          ></charts>
          <no-data-temporarily v-else class="flex-grow-1"></no-data-temporarily>
        </el-tab-pane>
        <!-- 数据表格 -->
        <el-tab-pane label="数据表格">
          <energy-table
            v-if="selectLabel == 1 && tableData"
            :tableData="tableData"
            class="none-height flex-grow-1 d-flex flex-column"
          ></energy-table>
          <no-data-temporarily v-else class="flex-grow-1"></no-data-temporarily>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>
<script>
import { BASE_URL } from '@/utils/request/request';
import Charts from '@/components/general/chart.vue';
import DurationSelector from '@/components/utils/duration-selector.vue';
import {
  getEquipProps,
  getPropsData,
  // getselectderive
} from '@/api/equipments/equipments';
import EnergyTable from '@/components/utils/energy-table.vue';
import ProjectTreeSelector from '@/components/utils/project-tree-selector.vue';
import Breadcrumbs from '@/components/utils/breadcrumbs.vue';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import SectionTitle from '@/components/utils/section-title.vue';

export default {
  name: 'query-pivot',
  components: {
    Charts,
    DurationSelector,
    EnergyTable,
    ProjectTreeSelector,
    Breadcrumbs,
    NoDataTemporarily,
    SectionTitle,
  },
  data() {
    return {
      selectEquipType: 0,
      equipTypeList: [
        {
          value: 0,
          label: '变压器',
        },
        {
          value: 1,
          label: '进出线',
        },
      ],
      selectLabel: 0,
      propsData: [],
      selectNode: null,
      selectPeriod: [],
      filterText: '',
      selectProperties: [],
      propertyList: [],
      nodeList: [],
      selectPropertiesStorage: [],
    };
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    chartsData() {
      if (this.propsData.length === 0) {
        return null;
      }
      const xSeriesData = this.propsData.xAxisData;
      const series = [];
      const unitSet = new Set();
      const legendArr = [];
      // 最小值数组
      const minArr = [];
      for (let i = 0; i < this.propsData.seriesData.length; i += 1) {
        const propSeries = this.propsData.seriesData[i];
        unitSet.add(propSeries.UnitName);
        legendArr.push(propSeries.ShuXingName);
        const list = propSeries.List ? propSeries.List : [];
        const map = new Map();
        for (let j = 0; j < list.length; j += 1) {
          map.set(list[j].Time, parseFloat(list[j].Value));
        }
        const arr = [];
        for (let k = 0; k < xSeriesData.length; k += 1) {
          const xSeriesItem = xSeriesData[k];
          const value = map.get(xSeriesItem);
          arr.push(value);
        }
        minArr.push(Math.min(...arr.filter((item) => item !== undefined)));
        let columType = 'line';
        if (propSeries.ShuXingID === '202' || propSeries.ShuXingID === '203' || propSeries.ShuXingID === '204' || propSeries.ShuXingID === '205') {
          columType = 'bar';
        }
        series.push({
          name: propSeries.ShuXingName,
          type: columType,
          barMaxWidth: 15,
          data: arr,
          smooth: true,
        });
      }
      const minValue = Math.min(...minArr);
      let minY = minValue - 10;
      if (minY < 0) {
        minY = 0;
      } else {
        minY = Math.ceil(minY);
      }
      console.log('minY', minY);
      return {
        legend: {
          data: legendArr,
          textStyle: {
            color: this.skinType ? '#fff' : '#333',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: true,
            data: xSeriesData,
            axisLabel: {
              color: this.skinType ? '#fff' : '#333',
            },
            axisLine: {
              color: this.skinType ? '#fff' : '#333',
            },
          },
        ],
        yAxis: {
          min: minY,
          type: 'value',
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#ccc',
            },
          },
        },
        series,
        color: ['#E6A23C', '#67C23A', '#F56C6C'],
      };
    },
    // tableData
    tableData() {
      if (this.propsData.length === 0) {
        return null;
      }
      const xSeriesData = this.propsData.xAxisData;
      const valueList = [];
      const legendArr = ['时间'];
      const propsSet = new Set();

      for (let i = 0; i < this.propsData.seriesData.length; i += 1) {
        const propSeries = this.propsData.seriesData[i];
        legendArr.push(
          `${propSeries.ShuXingName}${
            propSeries.UnitName ? `(${propSeries.UnitName})` : ''
          }`,
        );
        const list = propSeries.List ? propSeries.List : [];
        const map = new Map();
        for (let j = 0; j < list.length; j += 1) {
          map.set(list[j].Time, parseFloat(list[j].Value));
          propsSet.add('Time');
        }
        valueList.push(map);
      }
      const tabArr = [];
      for (let k = 0; k < xSeriesData.length; k += 1) {
        const xSeriesItem = xSeriesData[k];
        const item = { Time: xSeriesItem };
        for (let l = 0; l < valueList.length; l += 1) {
          const mapItem = valueList[l];
          item[`${l}`] = mapItem.get(xSeriesItem);
          propsSet.add(`${l}`);
        }
        tabArr.push(item);
      }

      return {
        data: tabArr,
        headers: legendArr,
        props: Array.from(propsSet),
      };
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    selectNode() {
      // 请求属性
      this.requestEquipPrpoerties();
    },
    // 时间端监听
    selectPeriod() {
      this.requestEquipPrpoerties();
    },
    selectProperties() {
      this.selectPropertiesStorage = this.selectProperties;
      this.requestPropertiesData();
    },
    tableData() {
      console.log('tableData', this.tableData);
    },
    selectLabel() {
      console.log('selectLabel', this.selectLabel);
    },
  },
  methods: {
    nodeListChangeListener(list) {
      this.nodeList = list;
    },
    selectNodeListener(selectItem) {
      this.selectNode = selectItem;
    },
    getNodeList(res) {
      const arr = [];
      for (let i = 0; i < res.length; i += 1) {
        const nodeInfo = res[i];
        if (this.nodeHasNode(nodeInfo, this.selectEquipType)) {
          arr.push(nodeInfo);
        }
      }
      return arr;
    },
    nodeHasNode(nodeInfo, equipType) {
      let types = null;
      if (equipType === 0) {
        types = ['byq'];
      } else {
        types = ['jx', 'cx'];
      }
      if (types.indexOf(nodeInfo.oType) >= 0) {
        return true;
      }
      if (!nodeInfo.Children) {
        return false;
      }
      for (let i = 0; i < nodeInfo.Children.length; i += 1) {
        const childInfo = nodeInfo.Children[i];
        if (this.nodeHasNode(childInfo, equipType)) {
          return true;
        }
      }
      return false;
    },
    // 请求数据
    requestPropertiesData() {
      if (!this.selectProperties || this.selectProperties.length === 0) {
        this.propsData = [];
        return;
      }
      const [startDate, endDate] = this.selectPeriod;
      console.log('zhangzhang3', this.selectPeriod);

      getPropsData({
        // eslint-disable-next-line max-len
        EquipmentIdStr: this.selectNode.IdStr,
        PropertyIds: this.selectProperties.join('|'),
        StartTime: startDate,
        EndTime: endDate,
        oType: this.selectNode.oType,
        // isCal: this.selectNode.isCal,
      })
        .then((res) => {
          this.propsData = res;
        })
        .catch(() => {
          this.propsData = [];
        });
    },
    selectDurationListener(duration) {
      this.selectPeriod = duration;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 获取属性列表
    requestEquipPrpoerties() {
      if (this.selectNode == null) {
        return;
      }
      console.log('选择的值', this.selectNode);
      //   if (['byq', 'jx', 'cx', ''].indexOf(this.selectNode.oType) < 0) {
      //     this.propertyList = [];
      //     this.selectProperties = [];
      //     return;
      //   }
      getEquipProps({
        // isCal: this.selectNode.isCal,
        EquipmentIdStr: this.selectNode.IdStr,
      })
        .then((res) => {
          const propertyList = res.sort((a, b) => a.PropertyId - b.PropertyId);
          this.propertyList = propertyList;
          // 判断是否包含缓存的属性
          if (this.selectPropertiesStorage.length !== 0) {
            this.selectProperties = [];
            // 找到相同属性
            const that = this;
            this.selectPropertiesStorage.forEach((e) => {
              const obj = propertyList.find((j) => j.PropertyId === e);
              if (obj) {
                that.selectProperties.push(obj.PropertyId);
              }
            });
          }
          if (this.selectProperties.length === 0) {
            this.selectProperties = propertyList
              .slice(0, 3)
              .map((prop) => prop.PropertyId);
          }
        })
        .catch(() => {
          this.propertyList = [];
          this.selectProperties = [];
        });
    },
    // 获取导出信息
    requestselectderive() {
      if (!this.selectProperties || this.selectProperties.length === 0) {
        this.propsData = [];
        return;
      }
      const [startDate, endDate] = this.selectPeriod;
      window.open(
        `${BASE_URL}${'/api/guangfu/v1/GetPropertyDataExcel'}?EquipmentIdStr=${
          this.selectNode.IdStr
        }&PropertyIds=${this.selectProperties.join(
          '|',
        )}&StartTime=${startDate}&EndTime=${endDate}&oType=${
          this.selectNode.oType
        }`,
      );
    },
  },
};
</script>
<style scoped>
.check-box-group + .check-box-group {
  margin-left: 1rem;
}
.props-container {
  padding: 0.5rem 1rem 1rem 1rem;
  margin-top: 1rem;
}
.el-checkbox.is-bordered {
  margin-top: 10px;
}
.el-tabs__content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.el-tab-pane {
  height: 0;
}
</style>
